import React, { useEffect, useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CartTale2";
import axios from "axios";
import { apiKey } from "../../../../config/config";
import MessageCard from "../../../../components/AdminCards/MessageCard";

function DailySaleReport() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const columns = [
    {
      header: "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: "Date",
      accessorKey: "date",
    },

    {
      header: "Total Sale",
      accessorKey: "total_payable",
    },
  ];
  const [data, setData] = useState([]);
  const [users, setUsers] = useState([]);
  const [error, setError] = useState(false);
  const [selectedUser, setSelectedUser] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  // const buttonDataa = [
  //   {
  //     buttonText: "Submit",
  //   },
  // ];

  const handleUserSelect = (e) => {
    setSelectedUser(e.value);
  };

  const [selectedOutlet, setSelectedOutlet] = useState();
  const handleOutletSelect = (e) => {
    setSelectedOutlet(e.value);
  };
  const selectButton = [
    {
      placeholder: "User",
      options: users,
      onChange: handleUserSelect,
    },
    // {
    //   placeholder: "Outlet",
    //   options: outlets,
    //   onChange: handleOutletSelect,
    //   role: "yes",
    // },
  ];

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/daily-sales-report`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: selectedOutlet || user?.user.outlet_id,
          user_id: selectedUser,
          start_date: startDate,
          end_date: endDate,
        },
      })
      .then((res) => {
        setData(res.data);
        setError(false);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error occured");
      })
      .finally(() => {});
  }, [
    endDate,
    selectedUser,
    startDate,
    selectedOutlet,
    user?.token,
    user?.user.outlet_id,
  ]);

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/user`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      })
      .then((res) => {
        const mappedCustomers = res.data.map((user) => ({
          value: user.id,
          label: user.name,
        }));
        setUsers(mappedCustomers);
        setError(false);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error occured");
      })
      .finally(() => {});
  }, [user?.token, user?.user.outlet_id]);

  if (error) {
    return <MessageCard error={error} />;
  }

  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={"Daily Sale Report"}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        // buttonDataa={buttonDataa}
        selectButton={selectButton}
        downloads={true}
        handleOutletSelect={handleOutletSelect}
      />
    </main>
  );
}

export default DailySaleReport;
